import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import "./DeleteConfirmationModal.scss";
import { IDeleteConfirmationModal } from "./IDeleteConfirmationModal";
import CloseIcon from "@mui/icons-material/Close";
import CustomModalActionButton from "../../MUIBaseComponents/Modal/CustomModalActionButton";

const DeleteConfirmationModal = ({
  open,
  handleClose,
  onConfirm,
  name,
  title,
  msg,
  isLoading = false,
  note,
  loadingText,
  buttonText,
  saveText,
}: IDeleteConfirmationModal) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: "20px",
          backgroundColor: "var(--background-color)",
          //  boxShadow: "0px 10px 40px var(--box-shadow-heatmap-table)",
          width: window.innerWidth > 768 ? "30%" : "100%",
          minWidth: { sm: "380px" },
          maxWidth: "480px",
          overflow: "hidden",
        },
      }}
    >
      <DialogTitle className="delete-modal-title">
        <div className="delete-title-header">
          <Typography variant="h6" className="heading">
            {title ?? "Delete"}
          </Typography>
          <IconButton onClick={handleClose} className="close-btn">
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>

      <DialogContent className="delete-modal-container">
        <Typography className="delete-details">
          {/* Are you sure you want to {msg ?? 'delete'} this {name ?? 'business'}? */}
          {msg}
        </Typography>

        {note && <Typography className="delete-note">{note}</Typography>}
      </DialogContent>

      <CustomModalActionButton
        className="delete-modal-buttons"
        handleClose={handleClose}
        onConfirm={onConfirm}
        cancelText="Cancel"
        saveText={buttonText || saveText || "Delete"}
        isLoading={isLoading}
        loadingText={loadingText}
      />
    </Dialog>
  );
};

export default DeleteConfirmationModal;
